<template>
  <div class="forget-password">
    <div class="forget-password-card">
      <div class="title">
        <div class="logo"></div>
        {{ $t("r.resetPassword") }}
      </div>
      <div v-if="result == null" v-loading="posting" class="content">
        <div class="content-item">
          <p class="label">{{ $t("resetPass.newPassword") }}</p>
          <div class="item">
            <el-input v-model="resetPasswordParams.newPassword" />
          </div>
        </div>
        <div class="content-item">
          <p class="label">{{ $t("resetPass.reEnterPassword") }}</p>
          <div class="item">
            <el-input v-model="reEnterPassword" />
          </div>
        </div>
        <el-button
          type="primary"
          class="submit"
          color="#f332e3"
          @click="resetPassword"
          @keyup.enter="resetPassword"
        >
          {{ $t("resetPass.submit") }}
        </el-button>
        <el-link
          type="primary"
          class="returnLogin"
          @click="$router.push('/login')"
        >
          {{ $t("resetPass.returnLogin") }}
        </el-link>
      </div>
      <div v-else-if="result" class="content">
        <el-result
          icon="success"
          :title="$t('resetPass.success.title')"
          :sub-title="$t('resetPass.success.tip')"
        />
      </div>
      <div v-else-if="!result" class="content">
        <el-result
          icon="error"
          :title="$t('resetPass.fail.title')"
          :sub-title="$t('resetPass.fail.tip')"
        >
          <template #extra>
            <el-button type="primary" @click="result = null">
              {{ $t("resetPass.back") }}
            </el-button>
          </template>
        </el-result>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  checkResetPasswordIdApi,
  resetPasswordApi,
} from "@/api/manager/managerApi";
import { ResetPasswordParams } from "@/types/validator";
import { ElMessage } from "element-plus";
import { isArray, some, startsWith } from "lodash-es";
import { onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

// 查询是否存在对应id
const checkId = async () => {
  const id = route.params.id;
  if (!id || id == "" || isArray(id) || startsWith(id, "resetPasswordEmail_"))
    return router.push({ name: "login" });
  const response = await checkResetPasswordIdApi(route.params.id as string);
  console.log(response);
};

// 重置密码参数
const resetPasswordParams = reactive<ResetPasswordParams>({
  code: (route.params.id as string) || "",
  newPassword: "",
});
const reEnterPassword = ref<string>("");

const result = ref<boolean | null>(null);
const posting = ref<boolean>(false);
const resetPassword = async () => {
  const flag = !some(resetPasswordParams, (value) => {
    // 检查是否为 null、undefined 或者 trim() 结果为空字符串
    return value == null || (typeof value === "string" && value.trim() === "");
  });
  if (reEnterPassword.value !== resetPasswordParams.newPassword) {
    ElMessage.error("两次输入的密码不一致");
  }
  if (flag) {
    posting.value = true;
    const response = await resetPasswordApi(resetPasswordParams);
    posting.value = false;
    console.log(response);
    result.value = response;
  }
};
onMounted(() => {
  checkId();
});
</script>
<style lang="less" scoped>
.forget-password {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: right;
  min-width: 800px;
  min-height: 600px;
  position: relative; /* 确保伪元素定位有效 */

  /* 移除直接的背景图片设置 */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("@/assets/loginbg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transform: scaleX(-1); /* 水平翻转 */
    z-index: -1; /* 确保背景在内容后面 */
  }
}
.forget-password-card {
  width: 600px;
  height: 400px;
  position: relative;
  right: 10vw;
  background-color: #fff;
  box-shadow: 0 0 15px 1px rgba(247, 102, 181, 0.548);
  position: relative;
}
.logo {
  width: 120px;
  height: 30px;
  background-image: url("../assets/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.title {
  background-color: #f332e3;
  height: 80px;
  width: 100%;
  display: flex;
  color: #ffffff;
  align-items: center;
  font-family: "SimHei";
  font-weight: bolder;
  letter-spacing: 1px;
  font-size: 24px;
  padding-left: 30px;
}
.captcha-image {
  cursor: pointer;
}
.content {
  display: flex;
  height: 280px;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
}
.content-item {
  display: flex;
  width: 90%;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}
.label {
  width: 30%;
  text-align: right;
  padding-right: 20px;
  font-family: "SimHei";
  letter-spacing: 1px;
  line-height: 40px;
  font-weight: bolder;
  font-size: 18px;
}
.item {
  width: 60%;
  display: flex;
  align-items: center;
}
.submit {
  width: 40%;
  height: 40px;
  font-size: 20px;
  font-family: "SimHei";
  font-weight: bolder;
  letter-spacing: 2px;
  margin-top: 20px;
}
.returnLogin {
  position: absolute;
  bottom: -20px;
  left: 30px;
}
</style>
